import React from 'react';

interface ModalOverlayProps {
  active: boolean;
  onClose: () => void;
  className?: string;
  children: React.ReactNode;
}

const ModalOverlay: React.FC<ModalOverlayProps> = ({ active, onClose, className, children }) => {
  if (!active) return null;

  return (
    <div
      className={`modal-overlay active ${className || ''}`}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      {children}
    </div>
  );
};

export default ModalOverlay;
